module.exports = __webpack_public_path__ + "static/media/j-hernandez.3e916157.md";